import store from "@/store";
import StringFilterModel from "@/components/Tables/Filters/models/stringFilterModel";
import {
  defaultHistoryFields,
  isDeletedField
} from "@/components/Tables/defaultFields";

let gymsFields = [
  {
    key: "name",
    label: "Название спортзала",
    filter: new StringFilterModel()
  },
  {
    key: "clients",
    label: "Клиенты спортзала"
  }
];

if (store.getters["user/hasRole"](["root", "admin"]))
  gymsFields = [
    ...gymsFields,
    {
      key: "prices",
      label: "Абонементы спортзала"
    },
    {
      key: "unionsDiscounts",
      label: "Скидки для профсоюзов"
    }
  ];

gymsFields.push(isDeletedField);

const gymHistoryFields = [
  {
    key: "name",
    label: "Название спортзала",
    filter: new StringFilterModel()
  },
  {
    key: "adders",
    label: "Добавляющие",
    filter: new StringFilterModel(),
    formatter: value => value.map(({ name }) => name).join(",\n")
  },
  {
    key: "managers",
    label: "Менеджеры",
    filter: new StringFilterModel(),
    formatter: value => value.map(({ name }) => name).join(",\n")
  },
  ...defaultHistoryFields
];

export { gymsFields, gymHistoryFields };
